// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  // Your EmailJS service ID (create at https://www.emailjs.com/)
  SERVICE_ID: 'service_ecn3cpa',
  
  // Your EmailJS template ID (create in EmailJS dashboard)
  TEMPLATE_ID: 'template_uutn0j9',
  
  // Your EmailJS public key (found in EmailJS account settings)
  PUBLIC_KEY: 'gouUcJ1ajaIAFp1zC',
  
  // Email address where all contact form emails will be sent
  TO_EMAIL: 'nextcoreictsolutions@gmail.com'
};

// EmailJS template parameters
export const getTemplateParams = (formData) => ({
  from_name: formData.name,
  from_email: formData.email,
  message: formData.message,
  to_email: EMAILJS_CONFIG.TO_EMAIL,
  reply_to: formData.email,
  // Additional fields for better email formatting
  subject: `New Contact Form Submission from ${formData.name}`,
  date: new Date().toLocaleDateString(),
  time: new Date().toLocaleTimeString()
});
